/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useState, type RefObject } from 'react';
import { AccordionGroup, Text, View } from '@az/starc-ui';
import TableOfContentsStyles from './TableOfContents.module.scss';
import { GroupHeading } from './GroupHeading';
import { useLabels } from '@/hooks/useLabels';
import { useHeadingStructure } from '../../hooks/useHeadingStructure';

const labelMap = {
  tocHeading: 'label_BLOG_TableOfContentsHeading',
};

type TableOfContentsProps = {
  contentRef: RefObject<HTMLDivElement | null>;
};

export const TableOfContents = ({ contentRef }: TableOfContentsProps) => {
  const [openAccordionNames, setOpenAccordionNames] = useState<string[]>([]);
  const { tocHeading } = useLabels(labelMap);
  const headingStructure = useHeadingStructure(contentRef.current);

  return (
    <View direction="column" className={TableOfContentsStyles.tableOfContents}>
      <Text size="175" weight="heavy" fontFamily="headline" textCase="uppercase">
        {tocHeading}
      </Text>
      <View>
        {headingStructure.length > 0 && (
          <AccordionGroup
            openAccordionNames={openAccordionNames}
            onGroupChange={(updatedNames) => {
              const lastGroup = updatedNames.at(-1);
              const shouldOpenLastGroup = lastGroup && lastGroup.split('~')?.[1] !== '0';
              setOpenAccordionNames(shouldOpenLastGroup ? [lastGroup] : []);
            }}
          >
            {headingStructure.map((heading) => (
              <GroupHeading key={heading.elementText} heading={heading} contentRef={contentRef} />
            ))}
          </AccordionGroup>
        )}
      </View>
    </View>
  );
};
